import { BookingReasons } from "@raskrask-dk/raskrask-utils";
import type DetailsState from "..";
import {Action} from "../../../action/action";

export const SET_BOOKING_REASONS = "SET_BOOKING_REASONS";
export class SetBookingReasons extends Action<typeof SET_BOOKING_REASONS, BookingReasons> {
  readonly type = SET_BOOKING_REASONS;
  protected state: DetailsState;

  constructor(state: DetailsState, bookingReasons?: BookingReasons | undefined) {
    super(state, bookingReasons);
    this.state = state;
  }
  /**
   * Business Logic:
   * Action is only doable if customer is of type "Private"
   * If product if either Package or CompanyLead this action should not be available
   * @returns
   */
  public isDoable(): boolean {
    const {customerType, product} = this.state;
    const isProductNotABooking = product.type == "Package" || product.type == "CompanyLead";
    const isPrivateCustomer = customerType === "Private";
    return !isProductNotABooking && isPrivateCustomer;
  }
  public isValid(): boolean {
    return this.isDoable();
  }
}
